export const VULNERABILITIES = {
  DASHBOARD: {
    TITLE: 'Infrastructure Vulnerabilities',
    OVERVIEW_TITLE: 'Infrastructure Dashboard',
  },
  SUMMARY: {
    VULNERABILITIES: 'Vulnerabilities',
    AFFECTED_HOSTS: 'Affected Hosts',
    PROVIDERS: 'Providers',
    SEVERITY_BREAKDOWN: 'Severity Breakdown',
    STATUS: 'Status',
    NO_DATA: 'No data',
  },
  TOP_RISK_HOSTS: {
    TITLE: 'Top Risk Hosts',
    NO_DATA: 'No data available',
  },
  TRENDS: {
    TITLE: 'Trends',
    LAST_SCAN: 'Last scan',
    TIME_RANGES: {
      LAST_12_MONTHS: 'Last 12 months',
      LAST_6_MONTHS: 'Last 6 months',
      LAST_3_MONTHS: 'Last 3 months',
    },
    CHART: {
      VULNERABILITIES: 'Vulnerabilities',
      CRITICAL: 'Critical',
      HIGH: 'High',
      MEDIUM: 'Medium',
      LOW: 'Low',
    },
  },
  LIST: {
    SEARCH_PLACEHOLDER: 'Search vulnerabilities...',
    EMPTY_STATE: 'No vulnerabilities found matching your criteria.',
  },
  FILTERS: {
    PROVIDERS: 'Providers',
    ACCOUNTS: 'Accounts',
    SEVERITY: {
      ALL: 'All',
      CRITICAL: 'Critical',
      HIGH: 'High',
      MEDIUM: 'Medium',
      LOW: 'Low',
    },
    STATUS: {
      OPEN: 'Open',
      CLOSED: 'Closed',
      MUTED: 'Muted',
    },
  },
  MUTE: {
    MUTE_BUTTON: 'Mute vulnerability',
    UNMUTE_BUTTON: 'Unmute vulnerability',
    DIALOG_TITLE: 'Reason for mute',
    SELECTION_SUMMARY: (selected: number, total: number) => `${selected} of ${total} affected instances selected`,
    JUSTIFICATION_LABEL: 'Justification',
    JUSTIFICATION_PLACEHOLDER:
      'Why is this vulnerability being muted? e.g. a false positive on this image, accepted risk until the instance is patched',
    CANCEL: 'Cancel',
    BANNER_TITLE: (muted: number, total: number) => `Muted · ${muted} of ${total} affected instances`,
    MUTED_BADGE: 'Muted',
    MUTED_BY: (name: string) => `Muted by ${name}`,
    BY_SCANNER: 'Muted by the vulnerability scanner',
    NOTHING_SELECTED_TOOLTIP: 'Select at least one affected instance',
    DORMANT_NOTE: 'This mute will apply again if the vulnerability is reported in a future scan',
    MUTE_SUCCESS: 'Vulnerability muted',
    UNMUTE_SUCCESS: 'Vulnerability unmuted',
    MUTE_PARTIAL: (muted: number, requested: number) =>
      `Muted ${muted} of ${requested} instances — the rest are no longer open`,
    UNMUTE_PARTIAL: (unmuted: number, requested: number) =>
      `Unmuted ${unmuted} of ${requested} instances — the rest were no longer muted`,
    MUTE_ERROR: 'Could not mute the vulnerability',
    UNMUTE_ERROR: 'Could not unmute the vulnerability',
  },
  ITEM: {
    HOSTS: 'hosts',
    MORE: 'more',
  },
  DRAWER: {
    SUMMARY: {
      TITLE: 'Summary',
      SEVERITY: 'Severity',
      CVSS: 'CVSS',
      HOSTS: 'Hosts',
    },
    DESCRIPTION: {
      TITLE: 'Description',
    },
    REMEDIATION: {
      TITLE: 'Remediation',
    },
    AFFECTED_HOSTS: {
      TITLE: 'Affected Hosts',
      FIELDS: {
        IP: 'IP',
        VPC: 'VPC',
        PORT_PROTOCOL: 'Port & Protocol',
        REGION: 'Region',
        STATUS: 'Status',
      },
      STATUS: {
        OPEN: 'Open',
        CLOSED: 'Closed',
        MUTED: 'Muted',
      },
    },
  },
}
